import { render } from "./App.vue?vue&type=template&id=8ba35abc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8ba35abc&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\shop2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__